import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { EstimateSource } from '@lune-fe/dapi-models'
import { LuneTheme, Text } from '@lune-fe/lune-ui-lib'
import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC } from 'react'

const { palette } = LuneTheme

interface EstimateCreationSourceChipProps {
    creationSource: EstimateSource
    filename: string | null
    sx?: SxProps
}

const getSourceColor = (source: EstimateSource): string => {
    const colorMap: Record<EstimateSource, string> = {
        api: palette.Data1100,
        dashboard: palette.Surface700,
        csv: palette.Data100,
        ecotransit_csv: palette.Data700,
        chain_io: palette.Data1700,
        widget: palette.Data400,
        ecotransit: palette.Data700,
        blue_yonder: palette.Data300,
        rfq: palette.Data600,
    }

    return colorMap[source]
}

const getSourceLabel = (source: EstimateSource, filename: string | null): string => {
    if (filename) {
        return filename
    }

    // Format source names
    const labelMap: Record<EstimateSource, string> = {
        api: 'API',
        dashboard: t`Dashboard`,
        csv: 'CSV',
        chain_io: 'chain.io',
        ecotransit_csv: 'EcoTransIT CSV',
        widget: t`Widget`,
        ecotransit: 'EcoTransIT',
        blue_yonder: 'BlueYonder',
        rfq: t`Tender`,
    }

    return labelMap[source]
}

export const EstimateCreationSourceChip: FC<EstimateCreationSourceChipProps> = ({
    creationSource,
    filename,
    sx,
}) => {
    useLingui()

    const color = getSourceColor(creationSource)
    const label = getSourceLabel(creationSource, filename)

    return (
        <Box
            title={label}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                px: 1,
                py: 1 / 2,
                borderRadius: '100px',
                backgroundColor: color + '30', // 30% opacity
                lineHeight: 1,
                whiteSpace: 'nowrap',
                ...sx,
            }}
        >
            <Text
                variant={'body3'}
                sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {label}
            </Text>
        </Box>
    )
}

export default EstimateCreationSourceChip
